import React from "react";
import firebase from "../firebase";

const Login = () => {
  const handleLogin = () => {
    var provider = new firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(() => {});
  };
  return (
    <div className="login-screen">
      <div>
      <img src="/gmn.png" alt="Webinar Gmn College" />
      <br/><br/>
      <button className="login-btn" onClick={handleLogin}>Login</button>
      </div>
    </div>
  );
};

export default Login;
